import request from '@/utils/http';

export const getUpdate = (data) => {
    return request({
        url: `/api-bms-web/depositManagement/updateDrawBack`,
        method: 'post',
        data
    });
};

// 退款附件查询
export const getUploadLook = (params) => {
    return request({
        url: `/api-bms-web/depositManagement/queryFile`,
        method: 'get',
        params
    });
};

// 押金电子签章撤回
export const getWithdrawal = (data) => {
    return request({
        url: `/api-bms-web/depositManagement/recallElectronic`,
        method: 'post',
        data
    });
};